import axios from 'axios';

const suggestURL = "https://api.cognitive.microsoft.com/bing/v7.0/Suggestions";
const searchURL = "https://api.cognitive.microsoft.com/bingcustomsearch/v7.0/";
const imageSearchURL = "https://westeurope.api.cognitive.microsoft.com/vision/v1.0/analyze?visualFeatures=Tags";

const suggestSubscriptionKey = 'ab49c45bf2b8424190ca787e851575ff';

const searchKey = "a219fa06b767411c9f8df16c50410f57";
const webAPI = "e66d0571-76c6-49d8-a6ef-990c738dac48";
const imageSearchKey = "0413827f16fc44ecb2230bb8c98f72b1";


export default class Search {

  /**
   * Bing auto suggest. Suggests a sentence based on a word
   * @param term used to make a suggestion on
   */
  static suggest(term: string) {
    return axios.get(suggestURL + '?q=' + term + ' &mkt=de-AT"', {
      headers: {
        'Ocp-Apim-Subscription-Key': suggestSubscriptionKey
      }
    }).then((result: any) => {
      return result;
    }).catch(err => console.log(err));
  }

  /**
   * Search in the bing search. Search videos, text or photos for a given term.
   * @param term search term
   * @param type video, text, photos
   */
  static search(term: string, type: string) {
    
    let searchType = "";
    if (type.length > 0) {
      searchType = type + 's/';
    }
    return axios.get(searchURL + searchType + 'search?q=' + term + '&customconfig=' + webAPI + '&mkt=de-AT', {
      headers: {
        'Ocp-Apim-Subscription-Key': searchKey
      }
    });
  }

  static searchByFile(searcfilehByFile: File) {
      return axios.post(imageSearchURL, searcfilehByFile, {
        headers: {
          'Ocp-Apim-Subscription-Key': imageSearchKey,
          'Content-Type': 'application/octet-stream'
        }
      })
  }
}